'use client';

import React from 'react';

interface FormFieldWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export default function FormFieldWrapper({ children, className = '' }: FormFieldWrapperProps) {
  return (
    <div className={`flex flex-col gap-0 ${className}`}>
      {children}
    </div>
  );
}